class CookieService {
	private static _instance: CookieService | null = null;
	/** Aligné sur REFRESH_TOKEN_TTL (1,5 jour) côté backend. */
	private static readonly SESSION_COOKIE_MAX_AGE_MS = (24 * 60 * 60 * 1000 * 3) / 2;
	private constructor() {
		// Singleton instantiation guard
		void 0;
	}

	public static getInstance(): CookieService {
		if (!CookieService._instance) {
			CookieService._instance = new CookieService();
		}
		return CookieService._instance;
	}

	/**
	 * @description : set a cookie with a name and a value that expire in 1.5 days (refresh token TTL)
	 * @throws {Error} If the name or the value is empty
	 */
	public setCookie(name: string, value: string): void {
		if (typeof document === "undefined") return;
		if (!name || !value) throw new Error("Cookie name or value is empty");
		const date = new Date();

		date.setTime(date.getTime() + CookieService.SESSION_COOKIE_MAX_AGE_MS);

		// Set it
		document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
		const verified = this.getCookie(name);
		if (verified !== value) {
			throw new Error(`Cookie write verification failed for ${name}`);
		}
	}

	public getCookie(name: string): string | undefined {
		if (typeof document === "undefined") return;
		const value = "; " + document.cookie;
		const parts = value.split("; " + name + "=");

		if (parts.length == 2) {
			const lastPart = parts.pop();
			if (!lastPart) {
				return;
			}
			return lastPart.split(";").shift();
		}

		return;
	}

	public deleteCookie(name: string): void {
		if (typeof document === "undefined") return;
		const date = new Date();

		// Set it expire in -1 days
		date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);

		// Set it
		document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
	}
}

// Export named only - no default export to avoid Webpack initialization order issues
export { CookieService };
